export default "__VITE_PUBLIC_ASSET__ae66f81c__"